<template>
  <ai-hero
    :variant="variant"
    :display-video="false"
    :hero-image="heroImage"
    :hero-video="heroVideo"
    :hero-title="title1"
    :hero-title2="title2"
    :hero-description="homePageDescription"
    home-page>
    <template #header>
      <div class="HomeHero-header" />
    </template>

    <template #footer>
      <div class="HomeHero-bar">
        <ai-typo
          as="span"
          variant="heading-04"
          color="white"
          class="HomeHero-bar-title">
          {{ $t('homepage.hero.bar.title') }}
        </ai-typo>

        <home-booking-bar />
      </div>
    </template>
  </ai-hero>
</template>

<script setup lang="ts">
import HomeBookingBar from './HomeBookingBar.vue';

import type { AiPicture } from '~~/domains/graphql';

interface HomeHeroProps {
  title1: string;
  title2: string;
  homePageDescription: string;
  variant?: 'positive' | 'inverse';
  heroImage: AiPicture;
  heroVideo?: AiPicture | null;
}
defineProps<HomeHeroProps>();
</script>

<style scoped lang="scss">
@use '@/assets/styles/utilities/colors';
@use '@/assets/styles/utilities/constants';
@use '@/assets/styles/utilities/mq';

.HomeHero-header {
  height: constants.$header-large;
}

.HomeHero-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(21, 21, 21, 0.65);
  padding-left: constants.$padding-02;
  padding-right: constants.$padding-02;
  padding-top: constants.$padding-01;
  padding-bottom: constants.$padding-01;

  @media (mq.$from-medium) {
    padding-left: constants.$padding-05;
    padding-right: constants.$padding-05;
    padding-top: constants.$padding-02;
    padding-bottom: constants.$padding-02;
  }
}

.HomeHero-bar-title {
  display: inline-block;
  width: 100%;
  color: colors.$white;
  text-align: center;
  margin-bottom: constants.$margin-00;

  @media (mq.$from-medium) {
    text-align: left;
    margin-bottom: constants.$margin-01;
  }
}
</style>
